import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=0bc844a9&scoped=true&"
import script from "./Avatar.vue?vue&type=script&lang=ts&"
export * from "./Avatar.vue?vue&type=script&lang=ts&"
import style0 from "./Avatar.vue?vue&type=style&index=0&id=0bc844a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc844a9",
  null
  
)

export default component.exports